import React from "react";
import {motion} from "motion/react";
import {endAnimation, startAnimation} from "@/stores/animationStore";
import TopInfoPanel from "@/components/TopInfoPanel";
import {useNav} from "@/hooks/useNav";
import {r} from "@/utils/responsive";
import {createRelativeClipPath} from "@/utils/svgPathConverter";

interface TopPanelLayerProps extends React.HTMLAttributes<HTMLDivElement> {
}

const TopPanelLayer: React.FC<TopPanelLayerProps> = ({
                                                         className,
                                                         ...props
                                                     }) => {
    const {isTransitioning, currentSection} = useNav();
    return (
        <div {...props}>
            {createRelativeClipPath("M323.041 52H0V0H1920V52H1657.38C1647.78 52 1638.5 48.5472 1631.24 42.272L1607.45 21.728C1600.19 15.4528 1590.91 12 1581.3 12H398.959C389.313 12 379.991 15.486 372.712 21.8158L349.288 42.1842C342.009 48.514 332.687 52 323.041 52Z", 1920, 52, "top_panel_mask")}
            {currentSection !== "screensaver" && (
                <motion.div
                    initial={{opacity: 0}}
                    animate={{opacity: 1}}
                    exit={{opacity: 0}}
                    transition={{duration: 0.8, ease: "easeIn"}}
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        willChange: "opacity",
                        transform: "translateZ(0)",
                        zIndex: 10,
                        userSelect: "none",
                        backdropFilter: "blur(74px)",
                        backgroundColor: '#818CD530',
                        width: r.vmax(1920),
                        height: r.vmax(52),
                        clipPath: "url(#top_panel_mask)",
                    }}
                >
                    <TopInfoPanel/>
                </motion.div>
            )}
        </div>
    );
};

export default TopPanelLayer;
